<template>
  <div class="CancleSubscription">
    <div class="return-information" v-if="WaitingToReturning">
      <returning-withdraw
        :device="tryBuyRatePlan"
        :replenshipment="replenishmentRatePlan"
        :device-return-infos="tryBuyReturnDetails"
        :replenshipment-return-infos="replenishmentReturnDetails"
      />
    </div>
    <!--  subscriptionDetails.returnStatus - > WaitingToReturning -->
    <template v-else>
      <template v-if="!onlyReplenishmentRatePlan && subscriptionDetails.ratePlans.length > 1">
        <div class="CancleSubscription_content">
          <not-only-replenshipment
            :device="tryBuyRatePlan"
            :replenshipment="replenishmentRatePlan"
            :device-return-infos="tryBuyReturnDetails"
            :replenshipment-return-infos="replenishmentReturnDetails"
            :right-to-return-days="rightToReturnDays"
            v-if="(tryBuyReturnDetails && tryBuyReturnDetails.returnable) || (replenishmentReturnDetails && replenishmentReturnDetails.returnable) || subscriptionDetails.ableToCancelReplenishment"
            :display-modify-button="displayModifyButton"
            :disabled-all-accordion="disabledAllAccordion"
          />
          <p v-if="tryBuyReturnDetails.unreturnableReason === 'PaidInFull' " class="Tips">
            {{ $t('subscription_details.accordion.cancel.message.afterPayInfull.text', 'Your device has been purchased') }}
          </p>

          <p v-if="tryBuyReturnDetails.unreturnableReason === 'InLockPeriod'" class="Tips">
            {{ $t('subscription_details.accordion.cancel.message.subscription.lockinPeriod', 'Sorry, you cannot start a cancellation until the "lock-in period" has passed') }}
          </p>
        </div>
      </template>

      <template v-if="!onlyReplenishmentRatePlan && subscriptionDetails.ratePlans.length === 1">
        <div v-if="(tryBuyReturnDetails.unreturnableReason !== 'InLockPeriod')">
          <only-device
            :device-return-infos="tryBuyReturnDetails"
            :device="tryBuyRatePlan"
            v-if="tryBuyReturnDetails && tryBuyReturnDetails.returnable"
            :right-to-return-days="rightToReturnDays"
          />
        </div>
        <p v-else-if="tryBuyReturnDetails.unreturnableReason === 'PaidInFull' " class="Tips">
          {{ $t('subscription_details.accordion.cancel.message.afterPayInfull.text', 'Your device has been purchased') }}
        </p>
        <p v-else-if="tryBuyReturnDetails.unreturnableReason === 'InLockPeriod'" class="Tips">
          {{ $t('subscription_details.accordion.cancel.message.subscription.lockinPeriod', 'Sorry, you cannot start a cancellation until the "lock-in period" has passed') }}
        </p>
      </template>

      <template v-if="onlyReplenishmentRatePlan">
        <div v-if="(subscriptionDetails.reasonToDisableCancellation !== 'InLockPeriod')">
          <only-replenshipment
            :replenshipment-return-infos="replenishmentReturnDetails"
            :replenshipment="replenishmentRatePlan"
            v-if="(replenishmentReturnDetails && replenishmentReturnDetails.returnable) || subscriptionDetails.ableToCancelReplenishment"
            :display-modify-button="displayModifyButton"
            :disabled-all-accordion="disabledAllAccordion"
            :right-to-return-days="rightToReturnDays"
          />
        </div>
        <p v-else-if="replenishmentReturnDetails.unreturnableReason === 'PaidInFull' " class="Tips">
          {{ $t('subscription_details.accordion.cancel.message.afterPayInfull.text', 'Your device has been purchased') }}
        </p>
        <p v-else-if="subscriptionDetails.reasonToDisableCancellation === 'InLockPeriod'" class="Tips">
          {{ $t('subscription_details.accordion.cancel.message.subscription.lockinPeriod', 'Sorry, you cannot start a cancellation until the "lock-in period" has passed') }}
        </p>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { find } from 'lodash'
  import NotOnlyReplenshipment from 'components/SubscriptionCancelSteps/NotOnlyReplenshipment'
  import OnlyReplenshipment from 'components/SubscriptionCancelSteps/OnlyReplenshipment'
  import OnlyDevice from 'components/SubscriptionCancelSteps/OnlyDevice'
  import { detectedCulture } from '@/utilities/common/culture'
  import returningWithdraw from 'components/SubscriptionCancelSteps/ReturningWithdraw'

  export default {
    name: 'subscription-cancel-section',

    data () {
      return {
        cultureCode: detectedCulture.code,
        discountedPurchaseValueToPay: null,
        cancelOption: null
      }
    },

    props: {
      displayModifyButton: {
        type: Boolean,
        default: false
      },
      disabledAllAccordion: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails']),

      ...mapState('culture', ['removeRefundBlock', 'countries']),

      tryBuyReturnDetails () {
        return this.subscriptionDetails.returnInfoDetails && this.subscriptionDetails.returnInfoDetails.tryBuyReturnDetails
      },

      replenishmentReturnDetails () {
        return this.subscriptionDetails.returnInfoDetails && this.subscriptionDetails.returnInfoDetails.replenishmentReturnDetails
      },

      rightToReturnDays () {
        return this.subscriptionDetails.returnInfoDetails && this.subscriptionDetails.returnInfoDetails.rightToReturnDays
      },

      WaitingToReturning () {
        return this.subscriptionDetails.ratePlans.length === 1 && ((this.tryBuyReturnDetails && this.tryBuyReturnDetails.returningWithdrawable) ||
        (this.replenishmentReturnDetails && this.replenishmentReturnDetails.returningWithdrawable))
      },

      onlyReplenishmentRatePlan () {
        return !!(this.subscriptionDetails.ratePlans.length === 1 && this.subscriptionDetails.ratePlans[0].modelType === 'Replenishment' || this.subscriptionDetails.ratePlans[0].modelType === 'ReplenishmentStandard')
      },

      tryBuyRatePlan () {
        return find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuy' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyPurchase' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciation' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciationPurchase' })
      },

      replenishmentRatePlan () {
        return find(this.subscriptionDetails.ratePlans, { modelType: 'Replenishment' }) ||
        find (this.subscriptionDetails.ratePlans, { modelType: 'ReplenishmentStandard' })
      }
    },

    methods: {
      openBuySubscriptionAccordion () {
        this.$parent.toggle('buy_your_subscription')
      }
    },

    components: {
      NotOnlyReplenshipment,
      OnlyReplenshipment,
      OnlyDevice,
      returningWithdraw
    },

    created () {
      this.$bus.$on('unPaidCharge-refreshed', discountedPurchaseValueToPay => {
        this.discountedPurchaseValueToPay = discountedPurchaseValueToPay
      })
    }
  }
</script>

<style lang="scss">
  .CancleSubscription {
    font-size: .16rem;

    &_ReasonForm {
      padding: .17rem .1rem;
      border: .02rem solid $blue;

      @include media(tablet) {
        padding: .25rem .16rem;
      }

      > h4 {
        font-size: .17rem;
        font-weight: 700;
        line-height: 1;
        margin-bottom: .22rem;
      }

      .CheckboxGroup {
        margin-bottom: .35rem;

        @include media(tablet) {
          margin-bottom: .3rem;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
        }
      }

      .Form_group {
        margin-bottom: .15rem;

        @include media(tablet) {
          flex-basis: 49%;
          flex-shrink: 1;
        }
      }

      .Form_group-choice {
        .Form_label {
          color: $blue;
          font-size: .16rem;
        }
      }

      .Form_textarea {
        > textarea {
          border-color: $blue;
        }

        .Form_label {
          font-size: .16rem;
          line-height: .24rem;
          margin-bottom: .05rem;
        }

        &.Form_group {
          margin-bottom: .2rem;
        }
      }

      .AppCheckbox {
        align-self: center;

        &_label {
          width: .14rem;
          height: .14rem;
          align-self: center;
          border-color: $blue;

          &::after {
            width: .1rem;
            height: .06rem;
          }
        }
      }

      .update_address_success {
        background-color: #f7fad4;
        color: #5f9920;
        line-height: .14rem;
        padding: .11rem .16rem;
        margin: .21rem 0 .16rem;

        @include media(tablet) {
          width: 50%;
        }
      }

      .selectRadio {
        li {
          span:nth-of-type(2) {
            max-width: 86%;
          }
        }
      }
    }

    .return-information {
      padding: 0 .1rem;
      font-size: .14rem;
      line-height: .24rem;

      @include media(tablet) {
        font-size: .16rem;
        padding: 0;
      }

      p {
        font-weight: 700;
      }

      .bundlesCancelSubscription {
        .tips {
          font-weight: 400;
          font-size: .16rem;
          line-height: .24rem;
          margin: .06rem 0 .2rem;
        }

        .AppButton {
          width: auto;

          @include media(tablet) {
            min-width: 30%;
          }
        }
      }

      span {
        color: $font-black;
        font-weight: 500;
      }

      .cancel-description {
        color: $font-black;
        font-weight: 500;
        margin: .3rem 0;
      }
    }

    .returnCancelled {
      .v--modal-background-click {
        .v--modal-box {
          .v--modal-container {
            .v--modal-content {
              text-align: center;

              .modal-content {
                margin-top: .3rem;
              }
            }
          }
        }
      }
    }

    .v--modal-overlay {
      .v--modal-box {
        .v--modal-container {
          .modal-content {
            height: auto !important;
          }
        }
      }
    }

    .address_form_edit.v--modal-overlay {
      .v--modal-box {
        .v--modal-container {
          .modal-content {
            min-height: 5.6rem !important;

            .cancel_closeModal {
              margin-right: 0 !important;
            }
          }
        }
      }
    }

    .CancleSubscription_content {
      .v--modal-box {
        .v--modal-container {
          .v--modal-content {
            .modal-content {
              .CancleSubscription_ReasonForm {
                .updateAddressButton {
                  justify-content: flex-start;
                }
              }

              .modal-button-warpper {
                margin-top: .3rem;
                justify-content: flex-end;

                .cancel_closeModal {
                  background-color: white;
                  color: $blue;
                  margin-right: .32rem;
                  width: auto;

                  &:disabled {
                    color: white;
                  }
                }

                .cancel_openModal {
                  width: auto;
                  padding: .08rem .4rem;
                }
              }
            }
          }
        }
      }
    }

    .OnlyReplenshipment {
      .v--modal-box {
        .v--modal-container {
          .v--modal-content {
            .modal-content {
              .CancleSubscription_ReasonForm {
                .updateAddressButton {
                  justify-content: flex-start;
                }
              }
            }
          }
        }
      }
    }

    .CancleSubscription_ReasonForm {
      border: none;

      .CheckboxGroup {
        .Form_group {
          .AppCheckbox {
            .AppCheckbox_label {
              border-color: black;
            }
          }

          .Form_label {
            color: black;
          }
        }
      }

      .tips {
        margin-bottom: .3rem;
      }

      .title {
        margin-bottom: .2rem;
      }
    }

    .Tips {
      margin-top: .1rem;
    }

    .replenishmentCancellationConfirm {
      .modal-content {
        p {
          font-size: .14rem;
          line-height: .18rem;
          margin-top: .16rem;
        }

        h4 {
          line-height: .22rem;
          font-size: .18rem !important;
          margin-top: .1rem;

          b {
            font-weight: 700;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
